import { render, staticRenderFns } from "./ClassDetails.vue?vue&type=template&id=1efe1d18"
import script from "./ClassDetails.vue?vue&type=script&lang=js"
export * from "./ClassDetails.vue?vue&type=script&lang=js"
import style0 from "./ClassDetails.vue?vue&type=style&index=0&id=1efe1d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports